export default "__VITE_ASSET__BUrlw97A__"